// extracted by mini-css-extract-plugin
export default {"container":"pagination-table_container__VYDvz"};